import React from 'react'
import RadarMetrics from '../../ActivePurchased/RadarMetrics'
import { similarityScores } from '../../../mockups/Profile/marketplace'


function DataSetDetails({ actionName, price, startDate, totalAccounts, endDate,
    quality_score, profile_completeness, avg_relevance_score, personality_profile, chat_history,
    discussion_activity, msg_per_chats, total_msg_per_chats,
}) {

    const dataList = {
        "Quality Score": quality_score,
        "Profile Completeness": profile_completeness,
        "Relevance Score": avg_relevance_score,
        "Personality Profile": personality_profile,
        "Chat History": chat_history,
        "Discussion Activity": discussion_activity
    }

    const getWidthClass = (score) => {
        return `w-[${score}%]`
    }





    return (
        <div className='flex flex-col md:flex-row justify-between px-2.5 py-4
     bg-white text-black md:p-4 rounded-lg'>

            {/* MAIN DATA */}
            <div className='w-full md:w-[55%] order-1 md:order-2'>

                <div className='flex justify-between mt-4'>
                    <p className='font-bold md:text-2xl w-[70%] mr-3'>
                    {actionName === "Active" ? "Full Data" : "Dataset Preview "}
                    </p>
            <p className='font-bold text-sm italic w-auto'>
            {actionName !== "Active" &&
             <span className='md:text-2xl not-italic text-[16px]'>${price} </span>
             }
                <br />
                from {startDate}
                <br />
                to {endDate}</p>
                </div>

                <p className='my-2 italic font-semibold text-xs md:text-[16px]'>
                    Extracted from: {totalAccounts} {totalAccounts < 2 ? "account" : "accounts"}
                </p>
                <div className='bg-[#353535] text-white p-2.5 md:p-4 text-justify rounded-md'>
                    <p className='indent-3'>Based off your search, we recommend this dataset
                        for your purposes. Our PolicyWeb has carefully curated
                        this set of data through an accumulation of our most
                        frequented users. This ensures that both you and our
                        trusted partners are happy with the information we
                        are providing, Things you may see include, most relevant
                        discussion threads, data relevant to your needs, and graphs
                        that analyze the use of the website by our users.</p>
                </div>



                {/* */}
                <div className='flex flex-col md:flex-row'>
                    <div className={`relative bg-[#353535] text-white my-4 px-2.5 py-4 sm:p-4
                    text-justify rounded-md
                     ${actionName === "Active" ? "md:w-[45%]" : "md:w-full" }`}>

                        <div className='my-4'>
                            <p className='text-center'>Chat Activity</p>

                            <div className='flex text-xs justify-between m-2'>
                                <p>Average Chats per week</p>
                                <p className=''>4.2</p>
                            </div>
                            <div className='flex text-xs justify-between m-2'>
                                <p>Messages per Chat</p>
                                <p className=''>{msg_per_chats}</p>
                            </div>
                        </div>

                        <div className='my-4'>
                            <p className='text-center'>Platform Engagement</p>

                            <div className='flex text-xs justify-between m-2'>
                                <p>Project Participation rate</p>
                                <p className=''>68%</p>
                            </div>
                            <div className='flex text-xs justify-between m-2'>
                                <p>Discussion Contributions</p>
                                <p className=''>456</p>
                            </div>
                        </div>

                    </div>

                        {actionName === "Active"  &&
                        <div className='md:w-[55%] mx-2 my-4'>
                            <RadarMetrics data={similarityScores} />
                        </div>
                         }

                </div>
            </div>


            {/* SIDE DATA */}

            <div className='w-full md:w-[40%] order-2 md:order-1 my-3 md:my-7'>
                <div className='bg-[#353535] text-white my-4 px-2.5 py-4 sm:p-4
     text-justify rounded-md'>
                    <p className='text-center'>Preview Data</p>

                    {Object.entries(dataList)?.slice(0, 3).map(([label, score], idx) => {
                        return (
                            <div key={idx} className='flex flex-col items-center text-xs justify-center
                 my-4 space-y-2'>
                                <p>{label}</p>
                                <div className='w-[90%] bg-white rounded-lg h-4'>
                                    {score > 0 &&
                                        <div className={`${getWidthClass(score)} bg-red-400 rounded-lg h-4 p-1`}>
                                            <p className='text-black text-xs'>{score}%</p>
                                        </div>
                                    }
                                </div>
                            </div>)
                    })}
                </div>


                <div className='relative bg-[#353535] text-white my-4 px-2.5 py-4 sm:p-4 text-justify rounded-md'>
                    <p className='text-center'>Profile Metrics BreakDown</p>

                    {Object.entries(dataList)?.slice(3)?.map(([label, score], idx) => {
                        return (
                            <div key={idx} className='flex flex-col items-center text-xs justify-center
                 my-4 space-y-2'>
                                <p>{label}</p>
                                <div className='w-[90%] bg-white rounded-lg h-4'>
                                    {score > 0 &&
                                        <div className={`${getWidthClass(score)} bg-red-400 rounded-lg h-4 p-1`}>
                                            <p className='text-black text-xs'>{score}%</p>
                                        </div>
                                    }
                                </div>
                            </div>)
                    })}

                </div>
            </div>


        </div>
    )
}

export default DataSetDetails
